import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { message as en } from '@/localization/en.json';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: { en },
});

const loadedLanguages = ['en'];

function setI18nLanguage(lang) {
  i18n.locale = lang;
  return lang;
}

export function loadLanguage(lang) {
  if (i18n.locale !== lang) {
    if (!loadedLanguages.includes(lang)) {
      return import(/* webpackChunkName: "lang-[request]" */ `@/localization/${lang}`)
        .then((obj) => {
          i18n.setLocaleMessage(lang, obj.message);
          loadedLanguages.push(lang);
          return setI18nLanguage(lang);
        });
    }
    return Promise.resolve(setI18nLanguage(lang));
  }
  return Promise.resolve(lang);
}

export const locales = process.env.LOCALES_META;

export default i18n;
